const booking = {
  root: "booking",
  root_plural: "bookings",
};
export default booking;
